import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type LearningPreferencesIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function LearningPreferencesIcon({
  className,
  pathClassName = "stroke-teachLoop-textPrimary",
  ...props
}: LearningPreferencesIconProps) {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      className={className}
    >
      <Path
        d="M2.756 16.359a1.09 1.09 0 001.154 1.198 16.576 16.576 0 013.54.337c1.635.2 3.197.794 4.552 1.732V6.448A10.16 10.16 0 007.45 4.695a16.597 16.597 0 00-3.605-.316 1.09 1.09 0 00-1.09 1.089v10.89zM21.248 16.359a1.089 1.089 0 01-1.154 1.154 16.576 16.576 0 00-3.54.338 10.16 10.16 0 00-4.552 1.775V6.448a10.16 10.16 0 014.552-1.753 16.597 16.597 0 013.605-.316 1.089 1.089 0 011.089 1.154V16.36zM5.621 8.233h1.252M5.621 14.245h1.834M5.78 11.24h3.35"
        stroke="#000"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
    </Svg>
  );
}

export default LearningPreferencesIcon;
